import React from 'react';
import { arrayOf, bool, func, object, string } from 'prop-types';

import ReactSelect from 'react-select';

import reactSelectStyles from 'css/reactSelectStyles';

/** Select form element based on ReactSelect */
const Select = ({
  className,
  config,
  disabled,
  haserror,
  name,
  onBlur,
  onChange,
  options,
  placeholder,
  styles,
  touched,
  value
}) => {
  const defaultGetOptionValue = (option) => option.value;
  const getOptionValue = config.getOptionValue || defaultGetOptionValue;

  // When <Select /> changes, let formik know which field to update
  const handleChange = (selectedOption) => {
    onChange(name, selectedOption ? getOptionValue(selectedOption) : undefined);
  };

  const handleBlur = () => {
    onBlur(name, true);
  };

  const isError = touched && haserror;

  const combinedStyles = {
    ...reactSelectStyles.select(isError, disabled),
    ...styles
  };

  return (
    <div className={className} data-testid={name}>
      <ReactSelect
        id={name}
        isDisabled={disabled}
        name={name}
        onBlur={handleBlur}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        styles={combinedStyles}
        value={value}
        {...config}
      />
    </div>
  );
};

Select.propTypes = {
  className: string,
  config: object,
  disabled: bool,
  haserror: bool,
  name: string.isRequired,
  onBlur: func,
  onChange: func,
  options: arrayOf(object).isRequired,
  placeholder: string,
  styles: object,
  touched: bool,
  value: object
};

Select.defaultProps = {
  className: '',
  config: {
    getOptionLabel: ({ label }) => label,
    getOptionValue: ({ value }) => value,
    isSearchable: true
  },
  onBlur: () => {},
  onChange: () => {},
  styles: {}
};

export default Select;
